// Copyright © 2021 Move Closer
import { getAbstractInputControlProps } from '../../_abstract';
import { BootstrapInputType, IconPosition } from './Input.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapInputProps = {
    ...getAbstractInputControlProps(),
    /**
     * The name of the icon that is to be prepended to the `<input>`.
     */
    icon: {
        type: String,
        required: false
    },
    /**
     * The position of the icon (left or right).
     */
    iconPosition: {
        type: String,
        required: false,
        default: IconPosition.Left
    },
    /**
     * Content for the `<label>` element.
     */
    label: {
        type: String,
        required: false
    },
    /**
     * Value for the `[type]` attribute.
     */
    type: {
        type: String,
        required: false,
        default: BootstrapInputType.Text
    }
};
